import { createAsyncThunk } from "@reduxjs/toolkit";
import _ from "lodash";
import { sendAsync } from "../../../app/applicationSlice";
import { RootThunkApi } from "../../../app/store";
import { getRecordOfAdverseReactionDetail, getRecordOfAdverseReactionExport, getRecordOfAdverseReactionList, getRecordOfAdverseReactionSubmit, RecordOfAdverseReactionListParams, SubmitParams } from "../../../services/recordOfAdverseReaction";
import { getUnqualifiedMedicinesLedgerDetail, getUnqualifiedMedicinesLedgerExport, getUnqualifiedMedicinesLedgerList, UnqualifiedMedicinesLedgerListParams } from "../../../services/unqualifiedMedicinesLedger";


//导出
export const getUnqualifiedMedicinesLedgerExportAsync = createAsyncThunk<
  void,
  RecordOfAdverseReactionListParams,
  RootThunkApi
>('drugQualityFile/getUnqualifiedMedicinesLedgerExportAsync ', async (params, api) => {
  return sendAsync(getUnqualifiedMedicinesLedgerExport(params), api)
})

